import Vue from 'vue';
import VueTimeago from 'vue-timeago';
import { enUS } from 'date-fns/locale';
import { es } from 'date-fns/locale';

Vue.use(VueTimeago, {
    name: 'Timeago',
    locale: 'en', // Default locale
    locales: { en: enUS, es },
});
